import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { Permission, isPermission } from '@optical/rbac';

import { AuthStore } from '../state/auth';

export const permissionCanActivateFn: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const requiredPermission = route.data['permission'];

  if (!isPermission(requiredPermission)) {
    throw new Error(`Route protected by invalid permission: ${requiredPermission}`);
  }

  return redirectIfUnauthorized(requiredPermission);
};

export const permissionCanActivateChildFn: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
) => {
  const requiredPermission = childRoute.data['permission'];

  if (!isPermission(requiredPermission)) {
    throw new Error(`Route protected by invalid permission: ${requiredPermission}`);
  }

  return redirectIfUnauthorized(requiredPermission);
};

/**
 * Redirects the user to the home page if they are not authorized to access the route
 *
 * @param requiredPermission Required permission to access the route
 * @returns True if the user has the required permission, false otherwise
 */
function redirectIfUnauthorized(requiredPermission: Permission): boolean {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const hasPermission = authStore.hasPermission(requiredPermission)();

  if (!hasPermission) {
    router.navigate(['/']);
  }

  return hasPermission;
}
